export const EMITTER_SLOT_COINS = {
    addAtBack: true,
    autoUpdate: true,
    emit: false,
    frequency: 0.01,
    emitterLifetime: 0.1,
    spawnChance: 1,
    particlesPerWave: 50,
    maxParticles: 50,
    lifetime: {min: 3, max: 3},
    pos: {x: 0, y: 0},
    behaviors: [
        {type: 'textureSingle', config: {texture: "ico-gold"}},
        {type: 'alpha', config: {alpha: {list: [{value: 1, time: 0}, {value: 0.5, time: 1}]}, minMult: 0.8}},
        {type: 'scale', config: {scale: {list: [{value: 0.1, time: 0}, {value: 2, time: 1}]}, minMult: 0.5}},
        {type: "rotation", config: {minStart: -60, maxStart: -120, minSpeed: 90, maxSpeed: 180, accel: 90}},
        {type: "moveAcceleration", config: {accel: {x: 0, y: 500}, minStart: 0, maxStart: 100}},
        {type: 'moveSpeedStatic', config: {min: 100, max: 500}},
    ],
};

export const EMITTER_SLOT_STARS = {
    addAtBack: true,
    autoUpdate: true,
    emit: false,
    frequency: 0.008,
    emitterLifetime: 0.1,
    spawnChance: 1,
    particlesPerWave: 20,
    maxParticles: 1000,
    lifetime: {min: 0.3, max: 1},
    pos: {x: 0, y: 0},
    behaviors: [
        {type: 'textureSingle', config: {texture: "particles/star"}},
        {type: "alpha", config: {alpha: {list: [{value: 1, time: 0}, {value: 0.1, time: 1}]}}},
        {type: "scale", config: {scale: {list: [{value: 0.1, time: 0}, {value: 0.5, time: 0.3}, {value: 0, time: 1}]}, minMult: 0.7}},
        {type: 'color', config: {color: {list: [{value: "#FFFF00", time: 0}, {value: "#FFFFFE", time: 0.7}, {value: "#FFFFFF", time: 1}]}}},
        {type: "moveSpeed", config: {speed: {list: [{value: 500, time: 0}, {value: 100, time: 1}]}, minMult: 0.3}},
        {type: "rotation", config: {"minStart": -180, "maxStart": 180, "minSpeed": 30, "maxSpeed": 45, "accel": 20}},
    ],
};
